import { useEffect } from "react";

const useRefetchOnFocus = (...callbacks: Array<() => void>) => {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        callbacks.forEach((cb) => cb());
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useRefetchOnFocus;
